import { Validation } from '../../../../interfaces/common';
import { Add } from '../../../../interfaces/invoice.interface';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';

export const validateAddForm = (formData: Add, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.property) {
    if (!formData.property) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.property,
        message: APP_ERROR_MESSAGES.invoices.addList.blankProperty,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.month) {
    if (!formData.month) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.month,
        message: APP_ERROR_MESSAGES.invoices.addList.blankMonth,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.year) {
    if (!formData.year) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.year,
        message: APP_ERROR_MESSAGES.invoices.addList.blankYear,
      });
    }
  }

  return validations;
};
